import { AdminNewsComponent } from './modules/admin/pages/admin-news/admin-news.component';
import {
  AdminAddEditAlbumComponent,
} from './modules/admin/pages/admin-add-edit-album/admin-add-edit-album.component';
import {
  AdminAddEditPageComponent,
} from './modules/admin/pages/admin-add-edit-page/admin-add-edit-page.component';
import {
  AdminAddEditNewsComponent,
} from './modules/admin/pages/admin-add-edit-news/admin-add-edit-news.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomepageComponent } from './modules/user/pages/homepage/homepage.component';
import {
  SinglePageComponent,
} from './modules/user/pages/single-page/single-page.component';
import { NotFoundComponent } from './modules/user/pages/not-found/not-found.component';
import {
  AdminDashboardComponent,
} from './modules/admin/pages/admin-dashboard/admin-dashboard.component';
import {
  AdminNavigationComponent,
} from './modules/admin/components/admin-navigation/admin-navigation.component';
import { AdminPagesComponent } from './modules/admin/pages/admin-pages/admin-pages.component';
import { AdminAlbumsComponent } from './modules/admin/pages/admin-albums/admin-albums.component';
import {
  AdminGeneralSettingsComponent,
} from './modules/admin/pages/admin-general-settings/admin-general-settings.component';
import {
  AdminMenuSettingsComponent,
} from './modules/admin/pages/admin-menu-settings/admin-menu-settings.component';
import {
  AdminSliderSettingsComponent,
} from './modules/admin/pages/admin-slider-settings/admin-slider-settings.component';
import { NewsListComponent } from './modules/user/pages/news-list/news-list.component';
import { SingleNewsComponent } from './modules/user/pages/single-news/single-news.component';
import {
  UserRoutingComponent,
} from './modules/user/components/user-routing/user-routing.component';
import { SingleAlbumComponent } from './modules/user/pages/single-album/single-album.component';
import { AlbumsComponent } from './modules/user/pages/albums/albums.component';
import {
  AdminTeachersComponent,
} from './modules/admin/pages/admin-teachers/admin-teachers.component';
import {
  AdminAddEditTeacherComponent,
} from './modules/admin/pages/admin-add-edit-teacher/admin-add-edit-teacher.component';
import {
  DepartmentsListComponent,
} from './modules/user/pages/departments-list/departments-list.component';
import {
  SingleDepartmentComponent,
} from './modules/user/pages/single-department/single-department.component';
import {
  AdminAdministrationComponent,
} from './modules/admin/pages/admin-administration/admin-administration.component';
import {
  AdminAddEditAdminstrationPersonComponent,
} from './modules/admin/pages/admin-add-edit-adminstration-person/admin-add-edit-adminstration-person.component';
import {
  AdministrationComponent,
} from './modules/user/pages/administration/administration.component';
import { ContactsComponent } from './modules/user/pages/contacts/contacts.component';
import {
  AdminFeedbackMessagesComponent,
} from './modules/admin/pages/admin-feedback-messages/admin-feedback-messages.component';
import {
  AdminSingleFeedbackMessageComponent,
} from './modules/admin/pages/admin-single-feedback-message/admin-single-feedback-message.component';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { AdminLoginComponent } from './modules/admin/pages/admin-login/admin-login.component';

const routes: Routes = [
  {
    path: 'login',
    component: AdminLoginComponent,
  },
  {
    path: '',
    component: UserRoutingComponent,
    children: [
      {
        path: '',
        component: HomepageComponent,
      },
      {
        path: 'news',
        component: NewsListComponent,
      },
      {
        path: 'news/:slug',
        component: SingleNewsComponent,
      },
      {
        path: 'page/:slug',
        component: SinglePageComponent,
      },
      {
        path: 'albums',
        component: AlbumsComponent,
      },
      {
        path: 'albums/:slug',
        component: SingleAlbumComponent,
      },
      {
        path: 'administration',
        component: AdministrationComponent,
      },
      {
        path: 'departments',
        component: DepartmentsListComponent,
      },
      {
        path: 'departments/:slug',
        component: SingleDepartmentComponent,
      },
      {
        path: 'contacts',
        component: ContactsComponent,
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
    ],
  },
  { path: 'admin',
    component: AdminNavigationComponent,
    canActivate: [
      AuthGuardService,
    ],
    children: [
      {
        path: '',
        component: AdminDashboardComponent,
      },
      {
        path: 'messages',
        children: [
          {
            path: '',
            component: AdminFeedbackMessagesComponent,
          },
          {
            path: ':id',
            component: AdminSingleFeedbackMessageComponent,
          },
        ],
      },
      {
        path: 'news',
        children: [
          {
            path: '',
            component: AdminNewsComponent,
          },
          {
            path: 'add',
            component: AdminAddEditNewsComponent,
          },
          {
            path: ':slug',
            component: AdminAddEditNewsComponent,
          },
        ],
      },
      {
        path: 'pages',
        children: [
          {
            path: '',
            component: AdminPagesComponent,
          },
          {
            path: 'add',
            component: AdminAddEditPageComponent,
          },
          {
            path: ':slug',
            component: AdminAddEditPageComponent,
          },
        ],
      },
      {
        path: 'teachers',
        children: [
          {
            path: '',
            component: AdminTeachersComponent,
          },
          {
            path: 'add',
            component: AdminAddEditTeacherComponent,
          },
          {
            path: ':id',
            component: AdminAddEditTeacherComponent,
          },
        ],
      },
      {
        path: 'administration',
        children: [
          {
            path: '',
            component: AdminAdministrationComponent,
          },
          {
            path: 'add',
            component: AdminAddEditAdminstrationPersonComponent,
          },
          {
            path: ':id',
            component: AdminAddEditAdminstrationPersonComponent,
          },
        ],
      },
      {
        path: 'albums',
        children: [
          {
            path: '',
            component: AdminAlbumsComponent,
          },
          {
            path: 'add',
            component: AdminAddEditAlbumComponent,
          },
          {
            path: ':slug',
            component: AdminAddEditAlbumComponent,
          },
        ],
      },
      {
        path: 'general-settings',
        component: AdminGeneralSettingsComponent,
      },
      {
        path: 'menu-settings',
        component: AdminMenuSettingsComponent,
      },
      {
        path: 'slider-settings',
        component: AdminSliderSettingsComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
